import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["notification"]

  connect() {
    // Auto-hide notifications after 5 seconds
    setTimeout(() => {
      this.close()
    }, 5000)
  }

  close() {
    this.element.style.opacity = "0"
    this.element.style.transition = "opacity 0.3s ease-out"

    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
